<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM12.1515 6.15564C12.3479 5.96154 12.3497 5.64496 12.1556 5.44855C11.9615 5.25213 11.645 5.25026 11.4485 5.44436L6.74046 10.097L5.15146 8.52667C4.95505 8.33256 4.63848 8.33443 4.44437 8.53084C4.25026 8.72725 4.25213 9.04382 4.44854 9.23793L6.38899 11.1556C6.58376 11.3481 6.89713 11.3481 7.09191 11.1556L12.1515 6.15564Z"
    fill="currentColor" />
</template>
